interface SourceRow {
  label: string;
  value: string;
  link?: boolean;
}

interface SourceCardProps {
  heading: string;
  rows: SourceRow[];
}

/**
 * 出典カード。出典元・データ・アクセス日等を定義リストで示す。
 */
export default function SourceCard({ heading, rows }: SourceCardProps) {
  return (
    <div className="bg-[#f8f6f0] border border-[#e2ddd2] p-6 sm:p-7">
      <h2 className="jba-display font-medium text-[#1a2942] text-lg mb-4">{heading}</h2>
      <dl className="space-y-2.5 text-[15px] font-['Noto_Serif_JP',serif]">
        {rows.map((row) => (
          <div className="flex flex-col sm:flex-row sm:gap-3" key={row.label}>
            <dt className="text-[#8f7a56] sm:w-40 shrink-0">{row.label}</dt>
            <dd className={row.link ? 'min-w-0 break-all' : 'text-[#333]'}>
              {row.link ? (
                <a href={row.value} target="_blank" rel="noopener noreferrer" className="text-[#8f7a56] underline decoration-[#a38e65]/50 hover:text-[#1a2942] transition-colors">{row.value}</a>
              ) : (
                row.value
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
